module.exports = __webpack_public_path__ + "media/images/front/icon_fb-8be0bd585560a59fe72597c3ec134825.png";